import { render, staticRenderFns } from "./BusDisplay.vue?vue&type=template&id=abdea928"
import script from "./BusDisplay.vue?vue&type=script&lang=js"
export * from "./BusDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports